export const config = {
  msite: {
    isBorderRadius: true,
    isImageBorderRadius: true,
    wishlistIconColor: '#121212',
    wishlistIconActiveColor: '#f97676',

    titleColor: 'Light_Black',
    descriptionColor: 'Dark_Grey',

    titleFontSize: 'T2',

    discountPriceColor: 'Light_Black',
    discountPriceFontSize: 'T2',
    discountPriceFontWeight: 'bold',

    actualPriceColor: 'Dark_Grey',
    actualPriceFontSize: 'T1',

    discountPercentColor: 'Jade',
    discountPercentFontSize: 'T1',

    oosBtnTextColor: 'Salmon',
    oosBtnBgColor: '#f3f3f3'
  },
  msiteLuxe: {
    isBorderRadius: true,
    wishlistIconColor: '#121212',
    wishlistIconActiveColor: '#121212',

    titleColor: 'Light_Black',
    descriptionColor: 'Dark_Grey',

    titleFontSize: 'T2',

    discountPriceColor: 'Light_Black',
    discountPriceFontSize: 'T2',
    discountPriceFontWeight: 'bold',

    actualPriceColor: 'Dark_Grey',
    actualPriceFontSize: 'T1',

    discountPercentColor: 'Jade',
    discountPercentFontSize: 'T1',

    oosBtnTextColor: 'Salmon',
    oosBtnBgColor: '#f3f3f3'
  },
  desktop: {
    isBorderRadius: false,
    wishlistIconColor: '#D5A249',
    wishlistIconActiveColor: '#D5A249',

    titleColor: 'Mongoose',
    descriptionColor: 'Grey_33',

    titleFontSize: 'T3',

    discountPriceColor: 'Light_Black',
    discountPriceFontSize: 'T3',
    discountPriceFontWeight: 'bold',

    actualPriceColor: 'Grey_33',
    actualPriceFontSize: 'T2',

    discountPercentColor: 'Mongoose',
    discountPercentFontSize: 'T2',

    oosBtnTextColor: 'Valencia',
    oosBtnBgColor: '#f5f5f5'
  },
  desktopLuxe: {
    isBorderRadius: false,
    wishlistIconColor: '#121212',
    wishlistIconActiveColor: '#121212',

    titleColor: 'Light_Black',
    descriptionColor: 'Light_Black',

    titleFontSize: 'T3',

    discountPriceColor: 'Light_Black',
    discountPriceFontSize: 'T4',
    discountPriceFontWeight: 'bold',

    actualPriceColor: 'Grey_98',
    actualPriceFontSize: 'T2',

    discountPercentColor: 'Light_Black',
    discountPercentFontSize: 'T2',

    oosBtnTextColor: 'Light_Black',
    oosBtnBgColor: '#f5f5f5'
  }
};
